import { IconLineClose } from "@kalodata/kds-design-icons";
import { Modal, type ModalProps } from "antd";
import { ClipModalFooter, type ClipModalFooterConfig } from "./ClipModalFooter";

export interface ClipModalProps extends ModalProps {
  bodyMaxHeight?: number | string;
  /** 声明式底栏配置。传入后由 ClipModal 渲染标准 Cancel + Primary 操作栏；完全自定义时改用 `footer` */
  footerConfig?: ClipModalFooterConfig;
}

export const ClipModal = (props: ClipModalProps) => {
  const { open, children, bodyMaxHeight, footerConfig, footer, styles: propsStyles, ...restProps } = props;

  const computedStyles: ModalProps["styles"] =
    bodyMaxHeight !== undefined && typeof propsStyles !== "function"
      ? { ...propsStyles, body: { ...propsStyles?.body, maxHeight: bodyMaxHeight, overflow: "auto" } }
      : propsStyles;

  const footerNode = footerConfig ? <ClipModalFooter {...footerConfig} /> : (footer ?? null);

  return (
    <Modal
      destroyOnHidden
      open={open}
      closeIcon={<IconLineClose size={20} />}
      mask={{ closable: true }}
      {...restProps}
      footer={footerNode}
      styles={computedStyles}
      classNames={{
        container: "p-[16px]! flex flex-col gap-y-[4px]",
        title: "text-[16px] font-semibold leading-[24px] text-kds-fg",
        header: "mb-[0px]!",
        body: "p-0! flex-1 min-h-0",
        footer: "m-0!",
        ...restProps.classNames,
      }}
    >
      {children}
    </Modal>
  );
};
